import * as actions from './events.actions'

const initialState = {
  executedEvent: null,
}

const actionsMap = {
  [actions.SET_EXECUTED_EVENT]: (state, action) => {
    const event = action.data
    return {
      ...state,
      executedEvent: event,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
